module.exports = "/img/11.8563fd.jpg";